import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  CreateUserOrderExternalManagedPaymentsDetailsRequestType,
  CreateUserOrderExternalManagedPaymentsDetailsResponseType,
  ExternalManagedPaymentServicesDetailsResponseType,
  GetExternalManagedPaymentServicesDetailsRequestType,
  GetPaymentProofExtractionResultRequestType,
  GetPaymentProofExtractionResultResponseType,
  GetUserOrderExternalManagedPaymentDetailsRequestType,
  InitiatePaymentProofExtractionRequestType,
  InitiatePaymentProofExtractionResponseType,
  UserOrderExternalManagedPaymentDetailsResponseType
} from './types';

import { NwExternalPaymentsServicesTypes } from '.';

type NetworkCallWithAuthType = <T>(
  api: ApisauceInstance,
  url: string,
  requestObject: Record<string, unknown>,
  method: string,
  options?: Record<string, unknown>
) => Promise<T>;

class NwExternalPaymentsServices implements NwExternalPaymentsServicesTypes {
  api: ApisauceInstance;
  networkCallWithAuth: NetworkCallWithAuthType;

  constructor(networkCallWithAuth: NetworkCallWithAuthType) {
    this.api = create({
      baseURL: `${Config['EXTERNAL_PAYMENTS_URL']}`
    });
    this.networkCallWithAuth = networkCallWithAuth;
  }

  getExternalManagedPaymentServicesDetails = (
    requestObject: GetExternalManagedPaymentServicesDetailsRequestType
  ): Promise<ExternalManagedPaymentServicesDetailsResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'external_managed/payment_services_details/get/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  createUserOrderExternalManagedPaymentsDetails = (
    requestObject: CreateUserOrderExternalManagedPaymentsDetailsRequestType
  ): Promise<CreateUserOrderExternalManagedPaymentsDetailsResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'user_order/external_managed/payments_details/create/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  getUserOrderExternalManagedPaymentDetails = (
    requestObject: GetUserOrderExternalManagedPaymentDetailsRequestType
  ): Promise<UserOrderExternalManagedPaymentDetailsResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'user_order/external_managed/payment_details/get/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  initiatePaymentProofExtraction = (
    requestObject: InitiatePaymentProofExtractionRequestType
  ): Promise<InitiatePaymentProofExtractionResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'payment_proof/extraction/initiate/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  getPaymentProofExtractionResult = (
    requestObject: GetPaymentProofExtractionResultRequestType
  ): Promise<GetPaymentProofExtractionResultResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'payment_proof/extraction/result/get/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };
}

export { NwExternalPaymentsServices };
